<ng-container
  [formGroup]="showChaptersForm">
  <yc-checkbox
    name="showChapters"
    [optionLabel]="showChaptersText"
    [centerLabel]="true"
    (onChange)="_changeMade()">
  </yc-checkbox>
</ng-container>